if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

(() => {
  const setup = (root = document) => {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.rkLoopReady || !gallery.closest('section')?.querySelector('.rk-wild')) return;
      const thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!thumbs || !viewer) return;
      gallery.dataset.rkLoopReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const items = () => Array.from(thumbs.querySelectorAll('[data-target]')).filter(item => item.clientWidth > 0);
      const currentIndex = () => Math.max(0, items().findIndex(item => item.querySelector('[aria-current="true"]')));
      const move = (step, from = currentIndex()) => {
        const all = items();
        if (!all.length) return;
        const next = all[(from + step + all.length) % all.length];
        gallery.setActiveMedia(next.dataset.target, false);
      };
      const sync = () => {
        thumbs.enableSliderLooping = mobile.matches;
        if (mobile.matches) {
          thumbs.querySelectorAll('button[name="previous"],button[name="next"]').forEach(button => button.disabled = false);
        } else if (thumbs.update) thumbs.update();
      };
      thumbs.addEventListener('click', event => {
        const button = event.target.closest('button[name="previous"],button[name="next"]');
        if (!mobile.matches || !button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        move(button.name === 'next' ? 1 : -1);
      }, true);
      let start = null;
      viewer.addEventListener('touchstart', event => {
        if (!mobile.matches || event.touches.length !== 1) return;
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY, index: currentIndex() };
      }, { passive: true });
      viewer.addEventListener('touchmove', event => {
        if (!start || !mobile.matches || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - start.x;
        const dy = event.touches[0].clientY - start.y;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) event.preventDefault();
      }, { passive: false });
      viewer.addEventListener('touchend', event => {
        if (!start || !mobile.matches) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1, start.index);
        start = null;
      }, { passive: true });
      viewer.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      let stripStart = null;
      const strip = thumbs.querySelector('.thumbnail-list');
      strip.addEventListener('touchstart', event => {
        if (!mobile.matches || event.touches.length !== 1) return;
        stripStart = { x: event.touches[0].clientX, y: event.touches[0].clientY, left: strip.scrollLeft, max: strip.scrollWidth - strip.clientWidth };
      }, { passive: true });
      strip.addEventListener('touchend', event => {
        if (!stripStart || !mobile.matches) return;
        const dx = event.changedTouches[0].clientX - stripStart.x;
        const dy = event.changedTouches[0].clientY - stripStart.y;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
          const all = items();
          if (dx < 0 && stripStart.left >= stripStart.max - 3) move(1, all.length - 1);
          if (dx > 0 && stripStart.left <= 3) move(-1, 0);
        }
        stripStart = null;
      }, { passive: true });
      mobile.addEventListener('change', sync);
      sync();
    });
  };
  const ready = () => customElements.whenDefined('media-gallery').then(() => customElements.whenDefined('slider-component')).then(() => setup());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
